import BrandList from "../Pages/Brand/BrandList";
import ContactList from "../Pages/Contact/ContactList";
import AddCourse from "../Pages/Course/AddCourse";
import CourseList from "../Pages/Course/CourseList";
import EditCourse from "../Pages/Course/EditCourse";
import EventList from "../Pages/Event/EventList";
import GalleryList from "../Pages/Gallery/GalleryList";
import Login from "../Pages/Login/Login";
import Profile from "../Pages/Profile/Profile";
import TestimonialsList from "../Pages/Testimonials/TestimonialsList";
import UseCaseList from "../Pages/UseCase/UseCaseList";
import UserList from "../Pages/User/UserList";

const publicRoutes = [{ path: "/login", component: <Login /> }];

const protectedRoutes = [
  {
    path: "/",
    exact: true,
    component: <CourseList />,
  },
  {
    path: "/addcourse",
    exact: true,
    component: <AddCourse />,
  },
  {
    path: "/editcourse",
    exact: true,
    component: <EditCourse />,
  },
  {
    path: "/contact-us",
    exact: true,
    component: <ContactList />,
  },
  {
    path: "/user",
    exact: true,
    component: <UserList />,
  },
  {
    path: "/testimonials",
    exact: true,
    component: <TestimonialsList />,
  },
  {
    path: "/gallery",
    exact: true,
    component: <GalleryList />,
  },
  {
    path: "/usecase",
    exact: true,
    component: <UseCaseList />,
  },
  {
    path: "/profile",
    exact: true,
    component: <Profile />,
  },
  {
    path: "/brand",
    exact: true,
    component: <BrandList />,
  },
  {
    path: "/event",
    exact: true,
    component: <EventList />,
  },
];

export { protectedRoutes, publicRoutes };
